(function () {
  'use strict';

  angular.module('services.catalog').service('CatalogService', CatalogService);

  function CatalogService($q, $http, $rootScope, $stateParams, GlobalService, ProductService, $cacheFactory, $window, $timeout) {
    const service = {
      getCatalogOffset: getCatalogOffset,
      updateCatalog: updateCatalog,
      clearCategoryCache: clearCategoryCache,
      isCatalogUpdating: false
    };

    let lastKind = null;
    let lastStoreId = null;

    const categoryCache = $cacheFactory('categoryCache');

    const EXPIRATION_TIME = 1 * 60 * 1000; // minutos
    const INACTIVITY_LIMIT = 2 * 60 * 1000; // minutos
    let lastActivityTime = Date.now();
    let inactivityTimer = null;

    iniciarMonitoreoInactividad();

    // Evento para cambiar de categoría
    if (!$rootScope.$$listeners.changeCategory || !$rootScope.$$listeners.changeCategory.length) {
      $rootScope.$on('changeCategory', function (event, data) {
        $stateParams.categoryId = data.categoryId;
        updateCatalog();
      });
    }

    // Evento para cambiar de submenú
    if (!$rootScope.$$listeners.changeSubmenu || !$rootScope.$$listeners.changeSubmenu.length) {
      $rootScope.$on('changeSubmenu', function (event, subcategoryId) {
        updateCatalog(subcategoryId);
      });
    }

    // Evento para recargar catálogo al volver desde el checkout
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
      if (fromState.name === 'checkout' && (toState.name === 'catalog' || toState.name === 'home')) {
        CatalogService.updateCatalog(GlobalService.activeCategory ? GlobalService.activeCategory.id : null, true); // Llama directamente a CatalogService con forceReload
      }
    });

    return service;

    function getCatalogOffset() {
      return 150;
    }

    function updateCatalog(selectedSubcategoryId, forceReload = false) {
      if (service.isCatalogUpdating && !forceReload) {
        console.log("Actualización de catálogo en curso, ignorando nueva petición.");
        return $q.resolve(false);
      }
      service.isCatalogUpdating = true;
      const defer = $q.defer();
      const config = GlobalService.configDelivery;
      const storeId = config.store.id;
      const kind = config.kind;
      let categoryId = $stateParams.categoryId ? parseInt($stateParams.categoryId) : (GlobalService.activeCategory ? GlobalService.activeCategory.id : 0);

      const storeOrKindChanged = lastKind !== kind || lastStoreId !== storeId;

      if (storeOrKindChanged) {
        lastKind = kind;
        lastStoreId = storeId;

        GlobalService.productCarousel = [];
        GlobalService.productAntojo = [];
        clearCategoryCache();
        console.log("Reiniciando productos del carrusel, antojo y cache debido a cambio de tienda o tipo de producto.");

        $q.all([
          ProductService.getProductsCarrusel(storeId, kind).then(function (res) {
            GlobalService.productCarousel = res.data.items || [];
          }),
          ProductService.getProductsAntojo(storeId, kind).then(function (res) {
            GlobalService.productAntojo = res.data.items || [];
          })
        ]).catch(function (error) {
          console.error("Error al obtener productos:", error);
        });
      }

      const isSameCategory = GlobalService.activeCategory && GlobalService.activeCategory.id === categoryId;
      const isSubmenuSelection = selectedSubcategoryId && GlobalService.activeCategory.secciones.some(function (sec) {
        return sec.id === selectedSubcategoryId;
      });

      if (isSameCategory && !isSubmenuSelection && !forceReload) {
        console.log('Recargando productos de la misma categoría (forzado)...');
      } else if (isSubmenuSelection) {
        console.log('Submenú seleccionado, no recargar.');
        service.isCatalogUpdating = false;
        defer.resolve(true);
        return defer.promise;
      }

      if (selectedSubcategoryId) {
        let parentCategory = null;
        for (let i = 0; i < GlobalService.productCategories.length; i++) {
          for (let j = 0; j < GlobalService.productCategories[i].secciones.length; j++) {
            if (GlobalService.productCategories[i].secciones[j].id === selectedSubcategoryId) {
              parentCategory = GlobalService.productCategories[i];
              break;
            }
          }
          if (parentCategory) break;
        }

        if (parentCategory) {
          categoryId = parentCategory.id;
          GlobalService.activeCategory = parentCategory;
        }
      }

      onlyCategoryProducts({ categoryId, kind, storeId, config })
      .then(function (status) {
        service.isCatalogUpdating = false;
        defer.resolve(status);
      })
      .catch(function (error) {
        console.error("Error al obtener productos de la categoría:", error);
        service.isCatalogUpdating = false;
        defer.reject(error);
      });

    return defer.promise;
    }

    function onlyCategoryProducts(input) {
      const defer = $q.defer();
      const { storeId, kind, categoryId } = input;

      const cacheKey = `${storeId}_${kind}_${categoryId}`;
      const cachedData = categoryCache.get(cacheKey);

      if (cachedData) {
        const now = Date.now();
        if (now - cachedData.timestamp > EXPIRATION_TIME) {
          console.log("Caché expirado para:", cacheKey);
          categoryCache.remove(cacheKey);
        } else {
          console.log('Usando datos desde el caché para la categoría:', categoryId);
          GlobalService.productCategories = cachedData.productCategories;
          GlobalService.menuData = cachedData.menuData;
          GlobalService.activeCategory = cachedData.activeCategory;
          $timeout(() => {
            $rootScope.$broadcast('catalogUpdated');
            defer.resolve(true);
          }, 0); // Forzar ejecución después del digest cycle
          return defer.promise;          
        }
      }

      ProductService.getProductsByStore(storeId, kind, categoryId)
        .then(function (result) {
          GlobalService.productCategories = result.data;
          let menuData = result.data.filter(c => c.visible === true);

          ProductService.getNewMenuCategories().then(({ data }) => {
            let menuHamburguer = data.response;
            menuData = menuData.map((categoria, i) => {
              categoria.secciones = menuHamburguer[i].secciones.map((seccion, j) => {
                return Object.assign({}, seccion, { imagen: menuHamburguer[i].secciones[j].imagen });
              });
              return Object.assign({}, categoria, {
                id: categoria.id,
                nombre: categoria.nombre,
                secciones: categoria.secciones,
                position: i,
                slugName: categoria.nombre.trim().toLowerCase().split(' ').join('-'),
                visible: categoria.visible,
              });
            });

            GlobalService.menuData = menuData;
          });

          let activeCategoryIndex = -1;
          for (let i = 0; i < GlobalService.productCategories.length; i++) {
            if (GlobalService.productCategories[i].id === categoryId) {
              activeCategoryIndex = i;
              break;
            }
          }

          if (activeCategoryIndex !== -1) {
            GlobalService.activeCategory = GlobalService.productCategories[activeCategoryIndex];
            GlobalService.productCategories[activeCategoryIndex].position = activeCategoryIndex;
          } else {
            GlobalService.activeCategory = result.data[0];
            result.data[0].position = 0;
          }

          categoryCache.put(cacheKey, {
            productCategories: GlobalService.productCategories,
            menuData: GlobalService.menuData,
            activeCategory: GlobalService.activeCategory,
            timestamp: Date.now()
          });

          $rootScope.$broadcast('catalogUpdated');
          defer.resolve(true);
        })
        .catch(function (error) {
          defer.reject(error);
        });

      return defer.promise;
    }

    function clearCategoryCache() {
      categoryCache.removeAll();
      console.log("Categoría cache limpiado.");
    }

    function iniciarMonitoreoInactividad() {
      const resetTimer = () => {
        lastActivityTime = Date.now();
        if (inactivityTimer) {
          $timeout.cancel(inactivityTimer);
        }
        inactivityTimer = $timeout(() => {
          const now = Date.now();
          if (now - lastActivityTime >= INACTIVITY_LIMIT) {
            clearCategoryCache();
            console.log("Cache limpiado por inactividad.");
          }
        }, INACTIVITY_LIMIT + 1000);
      };

      $window.addEventListener('mousemove', resetTimer);
      $window.addEventListener('keydown', resetTimer);

      resetTimer(); // Inicia el temporizador al cargar
    }
  }
})();
